let allMMTriggers = [
  ...document.querySelectorAll(
    '.header__nav--bottom .bottom-nav__nav-list-item .js-mm-toggle'
  ),
]

function handleFirstAndLastMenuElements(last, tabBackElement, currentIndex) {
  if (tabBackElement) {
    tabBackElement.addEventListener('keydown', function (e) {
      let isTabPressed = e.key === 'Tab' || e.keyCode === 9
      if (!isTabPressed) {
        return
      }

      if (e.shiftKey) {
        // focus on nav link
        let previousMenuId = currentIndex - 1
        let previousMenuItem =
          allMMTriggers[
            previousMenuId === allMMTriggers.length ? 4 : previousMenuId
          ]

        // need this to select right item
        setTimeout(function () {
          previousMenuItem.focus()
        }, 10)
      }
    })
  }

  last.addEventListener('keydown', function (e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9
    if (!isTabPressed) {
      return
    }

    if (e.shiftKey) {
      // do nothing
    } else {
      // focus next menu item
      let nextMenuId = currentIndex
      let nextMenuItem = allMMTriggers[nextMenuId]

      nextMenuItem.focus()
    }
  })
}

allMMTriggers.forEach((trigger) =>
  trigger.addEventListener('keydown', function (e) {
    let isTabPressed = e.key === 'Tab' || e.keyCode === 9

    if (!isTabPressed) {
      return
    }

    if (!this.contains(e.target)) {
      return
    }

    if (e.shiftKey) {
      // do nothing
    } else {
      // move focus to first element in megamenu

      let targetMenuIndex = allMMTriggers.indexOf(e.target)
      let targetMenu = document.querySelector(
        '#' + allMMTriggers[targetMenuIndex].id.split('trigger-')?.[1]
      )

      if (!targetMenu) {
        return
      }

      let allFocusItems = targetMenu.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      )

      let firstItem =
        targetMenu.querySelector('.megamenu__link-with-images:first-child') ||
        targetMenu.querySelector(
          '.megamenu__menu-first-level-ul > *:first-child'
        )

      let lastItem = allFocusItems[allFocusItems.length - 1]

      let tabBackElement =
        targetMenu.querySelector(
          '.megamenu__menu-first-level-ul > *:first-child > a'
        ) ||
        targetMenu.querySelector(
          '.megamenu__menu-first-level-ul > *:first-child > a'
        ) ||
        firstItem

      firstItem.focus()

      handleFirstAndLastMenuElements(lastItem, tabBackElement, targetMenuIndex)
    }
  })
)

class Megamenu extends HTMLElement {
  constructor() {
    super()
  }

  open() {
    this.classList.add('active')
    this.setAttribute('aria-hidden', false)
    document.querySelector(`#trigger-${this.id}`)?.setAttribute('aria-expanded', true)
    this.querySelector('.js-open-mobile-menu').focus()
  }

  close() {
    this.classList.remove('active')
    this.setAttribute('aria-hidden', true)
    document.querySelector(`#trigger-${this.id}`)?.setAttribute('aria-expanded', false)
  }
}

window.customElements.define('section-megamenu', Megamenu)
